module.exports = __webpack_public_path__ + "static/chapterhouse-dune-2544bff8e58affad0a6601594b3ebf08.jpg";